// extracted by mini-css-extract-plugin
export default {"container":"AddNewFamilyMemberPanel_container__1V3Db","label":"AddNewFamilyMemberPanel_label__kdwll"};